// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GroupsSwitch_wrapper__2zcAL","radioGroup":"GroupsSwitch_radioGroup__1eHp1"};